module.exports = __webpack_public_path__ + "static/media/addtask-screenshot.51187425.png";